module.exports = __webpack_public_path__ + "static/media/22-jan25jun25.f83699b8.pdf";